import RepositoryService from 'src/services/repository'

const resource = 'multiProject/session'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  sendAction: async ({ gameId, playerId, actionName }) => {
    const playerResourcePath = `${resource}/${gameId}/player`
    const actionPath = `${playerResourcePath}/${playerId}/${actionName}`

    const response = await RepositoryService.base.post(actionPath)

    return response?.data ?? response
  },
}
